angular.module('zc.zenclerkS')
  .directive('zcsHideWhenOem', zcsHideWhenOem);

zcsHideWhenOem.$inject = ['ZcsOemService'];
function zcsHideWhenOem(ZcsOemService) {
  return {
    restrict: 'A',
    link: link
  };

  function link(scope, elem, attrs) {
    scope.ZcsOemService = ZcsOemService;

    if(attrs.ngHide || attrs.ngShow) {
      console.warn('hide-when-oem component contains ng-hide or ng-show attributes', elem);
    }

    const originalDisplayProperty = elem.css('display');
    scope.$watch('ZcsOemService.get()', function(oemService) {
      const displayProperty = (oemService ? 'none' : originalDisplayProperty);
      elem.css({display: displayProperty});
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/zcs_hide_when_oem/zcs_hide_when_oem.directive.js